// Whether a redraw's catalog name path (next: { id, path }) should replace the
// address bar, given the previous redraw's (undefined before the first). A page
// opened with options of its own (a catalog name, options_json,
// option_name/option_value) keeps its url until the customer draws another
// combination: its first redraw only confirms it.
const catalogNamePathChanged = (previous, next, openedWithOptions) => {
  if(previous == undefined) { return !openedWithOptions }

  return previous.id != next.id || previous.path != next.path;
};

export default catalogNamePathChanged;
